import { withInstall } from '@jdesign-vue/utils'
import Popper from './src/popper.vue'

import JdPopperArrow from './src/arrow.vue'
import JdPopperTrigger from './src/trigger.vue'
import JdPopperContent from './src/content.vue'

export { JdPopperArrow, JdPopperTrigger, JdPopperContent }

export const JdPopper = withInstall(Popper)
export default JdPopper

export * from './src/popper'
export * from './src/trigger'
export * from './src/content'
export * from './src/arrow'
export * from './src/constants'

export type { Placement, Options } from '@popperjs/core'
